import React from "react";
import Frame from "./Frame";
import LoginScreen from "./LoginScreen";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginAction } from "./redux/actions/LoginActions";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(LoginAction.logout()),
});

// Convert to function component to use hooks
function WebPages() {
  const location = useLocation();
  const navigate = useNavigate();

  const showLogin = location.pathname.startsWith("/login");

  const toggleLogin = () => {
    if (location.pathname.startsWith("/login")) {
      navigate("/");
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      {showLogin ? <LoginScreen dismiss={toggleLogin} /> : null}
      <div className="content">
        <Frame path={location.pathname} />
      </div>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(WebPages);
